var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "기업회원 지도",
      "fullscreen": "",
      "persistent": "",
      "width": "1080",
      "maxWidth": "95%",
      "needsLogin": "",
      "eager": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.initiated ? _c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('recruitment-view-map', {
    attrs: {
      "place": _vm.employer.info
    }
  })], 1) : [_c('v-overlay', {
    attrs: {
      "absolute": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": "5",
      "color": "primary"
    }
  })], 1)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }